import React from 'react';
import IGNIZZA from '../logo/IGNIZZA.png';
// import QRCODE from '../qr/QRCODE.png';

const PackingSlip = ({ onClose, labelData }) => {
    const containerStyleN = {
        border: 'none',
        padding: '10px',
        width: '94%',
        marginTop: '10px',
        marginLeft: '10px',
        marginRight: '0px',
    };

    const containerStyle = {
        border: '1px solid #000',
        padding: '5px',
        width: '100%',
        marginTop: '5px',
        marginLeft: '0px',
        marginRight: '5px',
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        textAlign: 'center',
        fontFamily: 'Arial',

    };

    const cellStyle = {
        border: '1px solid #000',
        padding: '0px',
        fontWeight: 'normal',
        borderTop: 'none',
    };

    const cellStyleN = {
        border: 'none',
        padding: '0px',
        borderBottom: 'none'
    };

    // const cellStyleN1 = {
    //     borderBottom: '1px solid black',
    //     borderTop: 'none',
    //     borderLeft: 'none',
    //     borderRight: 'none',
    // };

    const cellStyleN1 = {
        borderBottom: '1px solid black',
        borderLeft: 'none',
        borderRight: 'none',
    };


    const cellStyleP = {
        borderBottom: 'none',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        padding: '0px',
    };

    const cellStyleP1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        padding: '0px',
    };

    const cellStyleL = {
        borderBottom: 'none',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: 'none',
        padding: '0px',
    };

    const cellStyleL1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: 'none',
        padding: '0px',
    };

    const headerStyle = {
        color: 'blue',
        fontStyle: 'italic',
        fontFamily: 'Newtown, sans-serif',
        textAlign: 'center',
    };

    const labelStyle = {
        marginTop: '5px',
        fontFamily: 'Arial',
        fontSize: '12px',
        marginRight: '5px',
    };

    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred ' + convert(num % 100).trim();
            if (num < 100000) return (convert(Math.floor(num / 1000)) + ' Thousand ' + convert(num % 1000)).trim();
            if (num < 1000000) return (convert(Math.floor(num / 100000)) + ' Lakh ' + convert(num % 100000)).trim();
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num);
    };

    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };
    const cellStyleNew = {
        border: '1px solid #000',
        padding: '0px',
        // marginTop: '15px',
        // height: '20px'
        marginTop: '10px',
        //height: '10px'
    };

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };


    return (
        <div style={containerStyleN}>
            {labelData && (
                <>
                    <div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', width: '100%' }}>
                            {/* Logo Section */}
                            <div style={{ width: '20%' }}>
                                <img
                                    src={IGNIZZA}
                                    alt="Company Logo"
                                    style={{
                                        maxHeight: '50px',
                                        width: 'auto',
                                        height: 'auto',
                                        marginBottom: '5px',
                                    }}
                                />
                            </div>
                        </div>


                    </div>
                    <table style={tableStyle}>
                        <tbody>
                            <tr>
                                <td colSpan="12" style={{ border: '1px solid black', padding: '5px', textAlign: 'center' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', fontWeight: 'normal', fontSize: '14px', marginTop: '2px' }}>
                                        PACKING LIST
                                    </div>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                    <table style={tableStyle}>
                        <tbody>
                            <tr>
                                {/* <td style={{ ...cellStyle, width: '52%', textAlign: 'left', maxHeight: '15%' }}> */}
                                <td style={{ ...cellStyle, textAlign: 'left', marginTop: '50px', maxHeight: '20%', width: '40%' }}>
                                    <h6 style={{ textAlign: 'left', marginTop: '5px', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>Exporter</h6>
                                    {labelData.SalePrint.CompanyName ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>{labelData.SalePrint.CompanyName} </h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden' }}></h6>
                                    )}

                                    {labelData.SalePrint.CompanyAddressLine ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>{labelData.SalePrint.CompanyAddressLine}{labelData.SalePrint.CompanyAddressLine2}  </h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Address Not Available</h6>
                                    )}
                                    {labelData.SalePrint.CompanyContactNumber1 ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>Mob # +91{labelData.SalePrint.CompanyContactNumber1}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>PhoneNo Not Available</h6>
                                    )}
                                    {labelData.SalePrint.CompanyEmail ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>Email:{labelData.SalePrint.CompanyEmail}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Email Not Available</h6>
                                    )}
                                    {labelData.SalePrint.CompanyGSTNumber ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>GSTIN :{labelData.SalePrint.CompanyGSTNumber}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>GSTIN Not Available</h6>
                                    )}
                                    {labelData.SalePrint.CompanyGSTNumber ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>IEC :{labelData.SalePrint.CompanyGSTNumber}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Email Not Available</h6>
                                    )}

                                </td>

                                <td style={{ ...cellStyle, width: '58%', textAlign: 'left', maxHeight: '15%' }}>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '5px', marginTop: '5px' }}>
                                        <div style={{ fontWeight: 'normal', marginRight: '5px', textAlign: 'left' }}>

                                            <div style={{ marginLeft: '5px', marginTop: '-15px' }}>Invoice Date <span style={{ marginLeft: '3px' }}>:</span> {new Date(labelData.SalePrint.BillDate).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'
                                            })}</div>
                                            <div style={{ marginLeft: '5px', marginTop: '-25px' }}>Invoice No <span style={{ marginLeft: '5px' }}>:</span> {labelData.SalePrint.InvoiceNo}</div>
                                        </div>
                                    </div>
                                    <hr style={{ marginTop: '2px' }}></hr>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '5px', marginTop: '-3px' }}>
                                        <div style={{ fontWeight: 'normal', marginRight: '5px', textAlign: 'left' }}>
                                            <div style={{ marginLeft: '5px' }}>Buyer's Order No & Date :  <span style={{ marginLeft: '5px' }}>:</span> {labelData.SalePrint.InvoiceNo}</div>
                                        </div>

                                    </div>
                                    <hr style={{ marginTop: '2px' }}></hr>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '0px', marginTop: '-7px' }}>
                                        <div style={{ fontWeight: 'normal', marginRight: '5px', textAlign: 'left' }}>
                                            <div style={{ marginLeft: '5px' }}>Other Reference</div>
                                        </div>

                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td style={{ ...cellStyle, width: '52%', textAlign: 'left', maxHeight: '15%' }}>
                                    <h6 style={{ textAlign: 'left', marginTop: '-0.50%', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>Consignee</h6>

                                    <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', marginTop: '0.50%', fontWeight: 'normal' }}>{labelData.SalePrint.CustomerName}</h6>
                                    {labelData.SalePrint.CustomerAddress ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>{labelData.SalePrint.CustomerAddress} </h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden' }}></h6>
                                    )}

                                    {labelData.SalePrint.CustomerContactNumber ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>TEL : {labelData.SalePrint.CustomerContactNumber} </h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Contact Number: Not Available</h6>
                                    )}
                                    {labelData.SalePrint.CustomerEmail ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>Email : {labelData.SalePrint.CustomerEmail}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Customer Email: Not Available</h6>
                                    )}
                                    {labelData.SalePrint.CustomerGSTNumber ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}> GST NO:{labelData.SalePrint.CustomerGSTNumber}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Not Available</h6>
                                    )}

                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '5px', marginTop: '-3px', width: '100%' }}>
                                        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid black', borderLeft: 'none' }}>
                                            <tr>
                                                <td style={{ border: '1px solid black', textAlign: 'left', width: '50%', padding: '5px' }}>
                                                    <h6 style={{ marginTop: '-5px', marginBottom: '2px', fontWeight: 'normal' }}>Pre-Carriage by</h6>
                                                    <h6 style={{ marginTop: '-1px', marginBottom: '2px', fontWeight: 'normal' }}>{labelData.SalePrint.PreCarriageBy}</h6>
                                                </td>
                                                <td style={{ border: '1px solid black', textAlign: 'left', width: '70%', padding: '5px' }}>
                                                    <h6 style={{ marginTop: '-5px', marginBottom: '2px', fontWeight: 'normal' }}>Place of Receipt by Pre-Carrier</h6>
                                                    <h6 style={{ marginTop: '-1px', marginBottom: '2px', fontWeight: 'normal' }}>{labelData.SalePrint.PlaceofReceiptsPreCarrier}</h6>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '5px', marginTop: '-6px', width: '100%' }}>
                                        <table style={{ borderLeft: 'none', width: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                                            <tr>
                                                <td style={{ border: '1px solid black', textAlign: 'left', width: '50%', padding: '5px' }}>
                                                    <h6 style={{ marginTop: '-5px', marginBottom: '2px', fontWeight: 'normal' }}>Vessel / Flight No</h6>
                                                    <h6 style={{ marginTop: '-1px', marginBottom: '2px', fontWeight: 'normal' }}>{labelData.SalePrint.VesselOrFlightNo}</h6>
                                                </td>
                                                <td style={{ border: '1px solid black', textAlign: 'left', width: '70%', padding: '5px' }}>
                                                    <h6 style={{ marginTop: '-5px', marginBottom: '2px', fontWeight: 'normal' }}>Port of loading</h6>
                                                    <h6 style={{ marginTop: '-1px', marginBottom: '2px', fontWeight: 'normal' }}>{labelData.SalePrint.PortofLoading}</h6>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '5px', marginTop: '-6px', width: '100%' }}>
                                        <table style={{ borderLeft: 'none', width: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                                            <tr>
                                                <td style={{ borderLeft: 'none', border: '1px solid black', textAlign: 'left', width: '50%', padding: '5px' }}>
                                                    <h6 style={{ marginTop: '-5px', marginBottom: '2px', fontWeight: 'normal' }}>Port of Discharge</h6>
                                                    <h6 style={{ marginTop: '-1px', marginBottom: '2px', fontWeight: 'normal' }}>{labelData.SalePrint.PortofDischarge}</h6>
                                                </td>
                                                <td style={{ borderLeft: 'none', border: '1px solid black', textAlign: 'left', width: '70%', padding: '5px' }}>
                                                    <h6 style={{ marginTop: '-5px', marginBottom: '2px', fontWeight: 'normal' }}>Place of Delivery</h6>
                                                    <h6 style={{ marginTop: '-1px', marginBottom: '2px', fontWeight: 'normal' }}>{labelData.SalePrint.PlaceofDelivery}</h6>
                                                </td>
                                            </tr>
                                        </table>

                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left', width: '100%', fontWeight: 'normal', fontSize: '14px', marginTop: '2px' }}>
                                        MARKS & NOS : {labelData.SalePrint.MarksandNos}
                                    </div>

                                </td>
                                <td style={{ ...cellStyle, width: '52%', textAlign: 'left', maxHeight: '15%' }}>
                                    <h6 style={{ textAlign: 'left', marginTop: '5px', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>Notify Party</h6>

                                    <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', marginTop: '0.50%', fontWeight: 'normal' }}>{labelData.SalePrint.CustomerName}</h6>
                                    {labelData.SalePrint.CustomerAddress ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>{labelData.SalePrint.CustomerAddress} </h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden' }}></h6>
                                    )}

                                    {labelData.SalePrint.CustomerContactNumber ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>TEL : {labelData.SalePrint.CustomerContactNumber} </h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Contact Number: Not Available</h6>
                                    )}
                                    {labelData.SalePrint.CustomerEmail ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>Email : {labelData.SalePrint.CustomerEmail}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Customer Email: Not Available</h6>
                                    )}
                                    {labelData.SalePrint.CustomerGSTNumber ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}> GST NO:{labelData.SalePrint.CustomerGSTNumber}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Not Available</h6>
                                    )}

                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '5px', marginTop: '-3px', width: '100%' }}>
                                        <table style={{ ...cellStyleN1, width: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                                            <tr>
                                                <td style={{ border: '1px solid black', textAlign: 'left', width: '50%', padding: '5px' }}>
                                                    <h6 style={{ marginTop: '-5px', marginBottom: '2px', fontWeight: 'normal' }}>Country of Orgin Of Goods</h6>
                                                    <h6 style={{ marginTop: '-2px', marginBottom: '2px', fontWeight: 'normal' }}>{labelData.SalePrint.CountryofOrigin}</h6>
                                                </td>
                                                <td style={{ border: '1px solid black', textAlign: 'left', width: '70%', padding: '5px' }}>
                                                    <h6 style={{ marginTop: '-5px', marginBottom: '2px', fontWeight: 'normal' }}>Country Of Final Destination</h6>
                                                    <h6 style={{ marginTop: '-2px', marginBottom: '2px', fontWeight: 'normal' }}>{labelData.SalePrint.CountryofDestination}</h6>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '0px', marginTop: '-6px', width: '100%' }}>
                                        <table style={{ ...cellStyleN, width: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                                            <tr>
                                                <td style={{ border: '1px solid black', textAlign: 'left', width: '40%', padding: '5px', marginBottom: '1px' }}>
                                                    <p style={{ marginTop: '-2px', marginBottom: '2px', fontWeight: 'normal', fontSize: '9px' }}>Terms Of delivery and Payment</p>
                                                    <p style={{ marginTop: '2px', marginBottom: '2px', fontWeight: 'normal', textAlign: 'center', fontSize: '9px' }}>FOB</p>
                                                    <p style={{ marginTop: '2px', marginBottom: '2px', fontWeight: 'normal', fontSize: '9px' }}>50% Advance and balance </p>
                                                    <p style={{ marginTop: '2px', marginBottom: '2px', fontWeight: 'normal', fontSize: '9px' }}>50% against Delivery </p>
                                                    <hr></hr>
                                                    <h6 style={{ marginTop: '-2px', marginBottom: '2px', fontWeight: 'normal' }}>AD CODE</h6>
                                                    <h6 style={{ marginTop: '-2px', marginBottom: '2px', fontWeight: 'normal' }}>{labelData.SalePrint.ADCode}</h6>
                                                </td>
                                                <td style={{ border: '1px solid black', textAlign: 'left', width: '70%', padding: '5px', marginBottom: '1px' }}>
                                                    <p style={{ marginTop: '2px', marginBottom: '2px', fontWeight: 'normal', textAlign: 'center', fontSize: '10px' }}>Payment of Integrated Tax</p>
                                                    <p style={{ marginTop: '1px', marginBottom: '2px', fontWeight: 'normal', textAlign: 'center', fontSize: '10px' }}>YES/NO : NO</p>
                                                    <p style={{ marginTop: '1px', marginBottom: '2px', fontWeight: 'normal', textAlign: 'left', fontSize: '7px' }}>SUPPLY MEANT FOR EXPORT FOR AUTHORISED</p>
                                                    <p style={{ marginTop: '1px', marginBottom: '2px', fontWeight: 'normal', textAlign: 'left', fontSize: '7px' }}>OPERATIONS UNDER LETTER OF UNDERTAKING</p>
                                                    <p style={{ marginTop: '1px', marginBottom: '2px', fontWeight: 'normal', textAlign: 'left', fontSize: '7px' }}>WITHOUT PAYMENT OF INTERGATED TAX</p>
                                                    <p style={{ marginTop: '1px', marginBottom: '2px', fontWeight: 'normal', textAlign: 'left', fontSize: '7px' }}>LUT #{labelData.SalePrint.LUTNumber} DT.{labelData.SalePrint.LUTDate}</p>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <td style={{ ...cellStyle, width: '1%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px', fontWeight: 'normal', fontSize: '8px' }}>Sl.No</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '25.5%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px', fontWeight: 'normal', fontSize: '8px' }}>DESCRIPTION OF GOODS</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '10%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px', fontWeight: 'normal', fontSize: '8px' }}>WEIGHT / PACKETS  in Grams</h6>
                                </td>

                                <td style={{ ...cellStyle, width: '10%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px', fontWeight: 'normal', fontSize: '8px' }}>NO.OF UNITS / PACKING (Nos)</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '10%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px', fontWeight: 'normal', fontSize: '8px' }}>NO.OF CARTONS (Nos)</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '7%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px', fontWeight: 'normal', fontSize: '8px' }}>NET WEIGHT in Kgs</h6>
                                </td>

                                <td style={{ ...cellStyle, width: '7%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px', fontWeight: 'normal', fontSize: '8px' }}>GROSS WEIGHT in Kgs</h6>

                                </td>
                                <td style={{ ...cellStyle, width: '7%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px', fontWeight: 'normal', fontSize: '8px' }}>BATCH CODE</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px', fontWeight: 'normal', fontSize: '8px' }}>MANUFACTURING DATE</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '10%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px', fontWeight: 'normal', fontSize: '8px' }}>EXPIRY DATE</h6>
                                </td>

                            </tr>
                        </thead>

                        <tbody>
                            {labelData && labelData.SalePrintItems.map((record, index) => {
                                const isLastRecord = index === labelData.SalePrintItems.length - 1;
                                return (
                                    <tr key={index} style={{ height: '20px' }}>
                                        <td style={{ ...cellStyleP, height: '20px', width: '1%', textAlign: 'left', borderBottom: 'none' }}>
                                            {record.ItemName && (
                                                <div style={{ marginLeft: '5px' }}>
                                                    <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                        {index + 1}
                                                    </label>
                                                </div>
                                            )}
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '25.50%', textAlign: 'left', borderBottom: 'none' }}>
                                            <div style={{ marginLeft: '5px', marginTop: '5px' }}>
                                                {record.ItemName && (
                                                    <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                        {record.ItemName}
                                                    </label>
                                                )}
                                            </div>
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '10%', textAlign: 'right', borderBottom: 'none' }}>
                                            <label style={{ fontSize: '9px', marginRight: '10px' }}>
                                                {record.PacketsInGrams !== 0 ? record.PacketsInGrams : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '10%', textAlign: 'right', borderBottom: 'none' }}>
                                            <label style={{ fontSize: '9px', marginRight: '10px' }}>
                                                {record.NoOfUnitPacking !== 0 ? record.NoOfUnitPacking : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '7%', textAlign: 'right', borderBottom: 'none' }}>
                                            <label style={{ fontSize: '9px', marginRight: '10px' }}>
                                                {record.Quantity !== 0 ? record.Quantity : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '9%', textAlign: 'right', borderBottom: 'none' }}>
                                            <label style={{ fontSize: '9px', marginRight: '10px' }}>
                                                {record.NetWeight !== 0 ? record.NetWeight : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '7%', textAlign: 'right', borderBottom: 'none' }}>
                                            <label style={{ fontSize: '9px', marginRight: '10px' }}>
                                                {record.GrossWeight !== 0 ? record.GrossWeight : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '10%', textAlign: 'right', borderBottom: 'none' }}>
                                            <label style={{ fontSize: '9px', marginRight: '10px' }}>
                                                {record.BatchNumber !== 0 ? record.BatchNumber : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '7%', textAlign: 'right', borderBottom: 'none' }}>
                                            <label style={{ fontSize: '9px', marginRight: '10px' }}>
                                                {record.ManufacturingDate && formatDateForInput(record.ManufacturingDate) !== "01/01/0001" ? formatDateForInput(record.ManufacturingDate) : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '12%', textAlign: 'right', borderBottom: 'none' }}>
                                            <label style={{ fontSize: '9px', marginRight: '10px' }}>
                                                {record.ExpirydDate && formatDateForInput(record.ExpirydDate) !== "01/01/0001" ? formatDateForInput(record.ExpirydDate) : ''}
                                            </label>
                                        </td>
                                    </tr>
                                );
                            })}

                          
                            {/* Grand Total Row */}
                            {labelData?.SalePrint && (
                                <tr style={{ fontWeight: 'bold', borderTop: '1px solid black' }}>
                                    <td colSpan="4" style={{ textAlign: 'right', fontSize: '10px', padding: '5px', borderLeft: '1px solid black' }}>
                                        Total:
                                    </td>
                                    <td style={{ textAlign: 'right', fontSize: '10px', padding: '5px', borderLeft: '1px solid black' }}>
                                        {labelData.SalePrint.TotalQuantity?.toFixed(2) ?? '0.00'}
                                    </td>
                                    <td style={{ textAlign: 'right', fontSize: '10px', padding: '5px', borderLeft: '1px solid black' }}>
                                        {labelData.SalePrint.TotalNetWeight?.toFixed(2) ?? '0.00'}
                                    </td>
                                    <td style={{ textAlign: 'right', fontSize: '10px', padding: '5px', borderLeft: '1px solid black' }}>
                                        {labelData.SalePrint.TotaGrossWeight?.toFixed(2) ?? '0.00'}
                                    </td>
                                    <td colSpan="3" style={{ borderRight: '1px solid black' }}></td>
                                </tr>
                            )}

                        </tbody>
                    </table>

                    <hr style={{borderCollapse: 'collapse', fontSize: '12px', marginTop: '-2px',fontWeight:'bold' }}></hr>

                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', marginTop: '-10px' }}>
                        <tbody>
                            <tr>
                                <td
                                    colSpan="12"
                                    style={{
                                        border: '1px solid black',
                                        padding: '2px 5px',
                                        height: '15px',
                                        borderTop: 'none',
                                        borderBottom: 'none',
                                    }}
                                >
                                    <h6
                                        style={{
                                            margin: '5px',
                                            fontSize: '14px',
                                            fontWeight: 'normal',
                                        }}
                                    >
                                        <AmountInWords amount={labelData.SalePrint.TotalAmount} />
                                    </h6>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table style={tableStyle}>
                        <tbody>
                            <tr>
                                <td style={{ ...cellStyle, textAlign: 'left', marginTop: '-50px', maxHeight: '20%', width: '68%' }}>
                                    <h6 style={{ marginRight: '10px', marginTop: '10px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}><span style={{ fontWeight: 'normal' }}>TOTAL NUMBER OF CARTONS :  <span style={{ marginLeft: '10px' }}>{(labelData?.SalePrint?.TotalQuantity ?? 0).toFixed(2)}</span> Nos</span></h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-17px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}><span style={{ fontWeight: 'normal' }}>TOTAL NET WEIGHT :  <span style={{ marginLeft: '32px' }}>{(labelData?.SalePrint?.TotalNetWeight ?? 0).toFixed(2)}</span> Kgs</span></h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}><span style={{ fontWeight: 'normal' }}>TOTAL GROSS WEIGHT :  <span style={{ marginLeft: '13px' }}>{(labelData?.SalePrint?.TotaGrossWeight ?? 0).toFixed(2)}</span> Kgs</span></h6>
                                    <h6 style={{ marginLeft: '10px', marginTop: '10%', fontFamily: 'arial', fontWeight: 'normal' }}><span style={{ fontWeight: 'normal' }}>We declare that this invoice shows the actual price of the </span></h6>
                                    <h6 style={{ marginLeft: '10px', fontFamily: 'arial', fontWeight: 'normal', marginTop: '-15px' }}><span style={{ fontWeight: 'normal' }}>goods described and all particulars are true and correct. </span></h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '15px', fontWeight: 'normal', marginLeft: '80%' }}>Signature and Date</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontWeight: 'normal', marginLeft: '80%' }}>{new Date(labelData.SalePrint.BillDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    })}</h6>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </>
            )
            }
            <style>
                {`
                    @media print {
                        @page {
                            margin: 0;
                        }
                        body {
                            margin: 5px;
                        }
                    }
                `}
            </style>
        </div >
    );
};

export default PackingSlip;
